import { HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpRequestCache {
	// Using the object gives more performance than a Map
	protected readonly requests: Record<string, Observable<HttpEvent<any>>> = {};

	public has(request: HttpRequest<any>): boolean {
		return this.key(request) in this.requests;
	}

	public get(request: HttpRequest<any>): Observable<HttpEvent<any>> {
		return this.requests[this.key(request)];
	}

	public set(request: HttpRequest<any>, response: Observable<HttpEvent<any>>): void {
		this.requests[this.key(request)] = response;
	}

	public delete(request: HttpRequest<any>): void {
		delete this.requests[this.key(request)];
	}

	protected key(request: HttpRequest<any>): string {
		return [request.urlWithParams, request.responseType].join('#');
	}
}
